<template>
  <div>
    <Teleport to="#fast-contact-title">
      <template v-if="view === 'signup'">Vos identifiants de connexion</template>
      <template v-else>Connexion</template>
    </Teleport>
    <div class="py-8">
      <div class="form-group" :class="{ 'form-group-invalid': store.errorsFor('email') }">
        <FastInput
          v-model="store.form.user.email"
          type="email"
          placeholder="Adresse email"
          name="email"
          autofocus
          autocomplete="email"
          :inner-class="store.errorsFor('email') ? 'is-invalid' : ''"
        />
        <p v-if="store.errorsFor('email')" class="text-sm text-danger">{{ store.errorsFor('email')[0] }}</p>
      </div>
      <div class="form-group" :class="{ 'form-group-invalid': store.errorsFor('password') }">
        <FastInput
          v-model="store.form.user.password"
          type="password"
          placeholder="Mot de passe"
          name="password"
          autocomplete="current-password"
          :inner-class="store.errorsFor('password') ? 'is-invalid' : ''"
        />
        <p v-if="store.errorsFor('password')" class="text-sm text-danger">{{ store.errorsFor('password')[0] }}</p>
      </div>
      <div
        v-if="view === 'signup'"
        class="form-group"
        :class="{ 'form-group-invalid': store.errorsFor('terms_of_service') }"
      >
        <div class="form-check">
          <input
            id="user_terms_of_service"
            v-model="store.form.user.terms_of_service"
            :class="{ 'is-invalid': store.errorsFor('terms_of_service') }"
            type="checkbox"
            name="user[terms_of_service]"
            aria-required="true"
            required="required"
            class="form-check-input"
          />
          <label for="user_terms_of_service" class="form-check-label font-normal text-gray">
            J'accepte les
            <a href="/pages/terms/general" target="_blank" class="text-gray underline">CGU</a>
            et la
            <a href="/pages/politique-de-confidentialite" target="_blank" class="text-gray underline">
              politique de confidentialité
            </a>
          </label>
        </div>
        <span v-if="store.errorsFor('terms_of_service')" class="invalid-feedback block text-sm">
          {{ store.errorsFor('terms_of_service')[0] }}
        </span>
        <p class="text-muted small text-justify px-6 mb-6">
          La société Codeur SAS qui édite Graphiste.com collecte ces informations afin de créer votre compte et de vous
          permettre d’utiliser la plateforme. Pour en savoir plus sur la gestion de vos données personnelles et pour exercer
          vos droits, vous pouvez consulter notre
          <a href="/pages/politique-de-confidentialite" target="_blank" class="text-gray underline">
            politique de confidentialité
          </a>
          .
        </p>
      </div>
      <!-- eslint-disable-next-line vue/no-v-html -->
      <p v-if="store.error" class="text-sm text-danger" v-html="store.error"></p>
    </div>
    <div class="mt-8 flex gap-2 max-md:flex-col items-center">
      <button class="btn font-semibold text-body" @click="$emit('goto', 'userContact')">Retour</button>
      <div class="grow"></div>
      <a v-if="view === 'signup'" class="text-muted max-md:order-last max-md:mt-2" href="#" @click.prevent="view = 'login'">
        J'ai déjà un compte
      </a>
      <a v-else class="text-muted max-md:order-last max-md:mt-2" href="#" @click.prevent="view = 'signup'">
        Je n'ai pas de compte
      </a>
      <vue-ladda
        :loading="loading"
        class="btn btn-primary py-4 px-8 md:ml-auto max-md:w-full"
        :disabled="!completed"
        @click="submit"
      >
        <template v-if="view === 'signup'">Enregistrer et continuer</template>
        <template v-else>Se connecter et continuer</template>
      </vue-ladda>
    </div>
  </div>
</template>

<script setup>
/* global defineEmits */

import { computed, ref, watch } from 'vue'
import { useApi } from '@/apps/shared/composables'
import { useMainStore } from '../stores/main'
import { useSendMessage } from '../composables/useSendMessage'
import FastInput from '@/apps/shared/components/FastInput.vue'
const store = useMainStore()

const view = ref('signup')
watch(
  () => view.value,
  () => store.resetErrors()
)

const completed = computed(() => {
  return store.form.user.email.length > 0 && store.form.user.password.length > 0
})

const api = useApi()
const emit = defineEmits(['goto'])
const sendMessage = useSendMessage(emit)
const loading = ref(false)

const submit = async () => {
  if (loading.value) return
  store.resetErrors()
  loading.value = true
  try {
    const params = view.value === 'signup' ? store.signupParams : store.loginParams
    const { data: userData } = await api.post(`/${view.value}`, params)
    store.loggedUser = userData.user
    await sendMessage(view.value)

    const matomoUrl = new URL(window.location.href)
    matomoUrl.searchParams.set('publication', 'message')
    if (view.value === 'signup') matomoUrl.searchParams.set('inscription', 'client')
    window._paq.push(['setCustomUrl', matomoUrl])
    window._paq.push(['trackPageView'])
  } catch (error) {
    const body = error.response.data
    if (!body) return
    if (body.errors?.from_fast_contact && body.errors?.from_fast_contact[0] === 'quota_exceeded') {
      emit('goto', 'spam')
    } else if (body.errors) {
      store.errors = body.errors
    } else if (body.error) {
      store.error = body.error
    }
  }
  loading.value = false
}
</script>
